import uuid from 'uuid/v4';
export var actions = {
    addTodo: function (label) { return ({ type: 'addTodo', id: uuid(), label: label }); },
    remove: function (id) { return ({ type: 'remove', id: id }); },
    complete: function (id) { return ({ type: 'complete', id: id }); },
    clear: function () { return ({ type: 'clear' }); },
    setFilter: function (filter) { return ({ type: 'setFilter', filter: filter }); },
    edit: function (id, label) { return ({ type: 'edit', id: id, label: label }); }
};
